var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11636",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11637",
    d: "M7 8h8",
    fill: "none",
    stroke: "#13910a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11638",
    d: "M16.884 13.88l-.394.418-.394-.419a2.359 2.359 0 00-3.256-.172h0a2.387 2.387 0 00-.29 3.305A23.12 23.12 0 0016.49 21a23.319 23.319 0 004.026-4.094 2.293 2.293 0 00-.324-3.153l-.043-.037a2.363 2.363 0 00-3.265.165z",
    fill: "none",
    stroke: "#13910a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11639",
    d: "M10 21H5a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2v4",
    fill: "none",
    stroke: "#13910a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default SvgStep5;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Americo/icons/step_5.svg
// module id = 7662
// module chunks = 13